export const INSERT_INFO_PANEL_COMMAND = 'insertInfoPanel';

export enum DocumentInfoPanelTypes {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
